(function () {
  function money(cents) {
    var z = (Number(cents) || 0) / 100;
    return z.toLocaleString('pl-PL', {
      minimumFractionDigits: Number.isInteger(z) ? 0 : 2,
      maximumFractionDigits: 2
    }) + ' zł';
  }
  function textToCents(text) {
    var raw = String(text || '').replace(/\s+/g, ' ').replace(/[^\d,.-]/g, '').trim();
    if (!raw) return 0;
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var decimalIndex = Math.max(lastComma, lastDot);
    var normalized;
    if (decimalIndex > -1 && raw.length - decimalIndex <= 3) {
      normalized = raw.slice(0, decimalIndex).replace(/[^\d-]/g, '') + '.' + raw.slice(decimalIndex + 1).replace(/[^\d]/g, '');
    } else {
      normalized = raw.replace(/[^\d-]/g, '');
    }
    var value = parseFloat(normalized);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }
  function getElementText(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function findCompareElement(host, shadowRoot, wrapper, saleText, fallbackScope) {
    var shadowSelectors = [
      '.dmixer-dp-original-price',
      '.dmixer-dp-compare',
      '.dmixer-dp-original',
      '[class*="original"]',
      's',
      'del'
    ];
    for (var i = 0; i < shadowSelectors.length; i++) {
      var found = shadowRoot.querySelector(shadowSelectors[i]);
      if (found && getElementText(found) && getElementText(found) !== saleText) return found;
    }
    var lightSelectors = [
      '.dmixer-original-price',
      '.dmixer-dp-original-price',
      '[class*="original"]',
      's',
      'del',
      '.price-item--regular'
    ];
    var scopes = [host, wrapper, fallbackScope || document];
    for (var s = 0; s < scopes.length; s++) {
      if (!scopes[s]) continue;
      for (var j = 0; j < lightSelectors.length; j++) {
        var item = scopes[s].querySelector(lightSelectors[j]);
        if (item && getElementText(item) && getElementText(item) !== saleText) return item;
      }
    }
    return null;
  }
  function readDiscountMixerPair(scope) {
    var rootScope = scope || document;
    var hosts = [].slice.call(rootScope.querySelectorAll('dmixer-discounted-price'));
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var shadowRoot = host.shadowRoot;
      if (!shadowRoot) continue;
      var saleEl = shadowRoot.querySelector('.dmixer-dp-price');
      var saleText = getElementText(saleEl);
      var saleCents = textToCents(saleText);
      if (!saleCents) continue;
      var wrapper = host.closest('.dmixer-price-wrapper, .dmixer-price') || rootScope.querySelector('.dmixer-price-wrapper, .dmixer-price, #google_prices, .main_price');
      var compareEl = findCompareElement(host, shadowRoot, wrapper, saleText, rootScope);
      var compareCents = textToCents(getElementText(compareEl));
      return { saleCents: saleCents, compareCents: compareCents };
    }
    return null;
  }
  function renderPricePill(el, baseCents, saleCents) {
    if (!el) return;
    if (saleCents && saleCents < baseCents - 1) {
      var discount = Math.max(1, Math.round((1 - saleCents / baseCents) * 100));
      el.innerHTML = '<s class="ecm-pill-compare">' + money(baseCents) + '</s><span class="ecm-pill-current">' + money(saleCents) + '</span><span class="ecm-pill-sale">-' + discount + '%</span>';
      return;
    }
    el.textContent = money(baseCents);
  }
  document.querySelectorAll('[data-ecm]').forEach(function (root) {
    var previews = [].slice.call(root.querySelectorAll('[data-ecm-preview]'));
    var captions = [].slice.call(root.querySelectorAll('[data-ecm-preview-caption]'));
    var colorWrap = root.querySelector('[data-ecm-colors]');
    var materialProp = root.querySelector('[data-ecm-prop-material]');
    var trimProp = root.querySelector('[data-ecm-prop-trim]');
    var priceEl = root.querySelector('[data-ecm-price]');
    var comparePriceEl = root.querySelector('[data-ecm-compare-price]');
    var discountBadgeEl = root.querySelector('[data-ecm-discount-badge]');
    var submitPrice = root.querySelector('[data-ecm-submit-price]');
    var variantInput = root.querySelector('[data-ecm-variant-id]');
    var setName = root.querySelector('[data-ecm-set-name]');
    var setPricePill = root.querySelector('[data-ecm-set-pricepill]');
    var colorName = root.querySelector('[data-ecm-color-name]');
    var discountSource = root.querySelector('[data-ecm-discount-source]');
    var sectionId = root.getAttribute('data-section-id') || '';
    var productHandle = root.getAttribute('data-product-handle') || '';
    var selectedSet = null;
    var discountCache = {};        // variantId -> { saleCents, compareCents }
    var inflightAbort = null;      // AbortController of the current fetch
    var refreshTimer = null;       // debounce timer
    var jobToken = 0;              // invalidates stale async jobs
    var userInteracted = false;    // stop background prefetch once the user picks

    function selectedBaseCents() {
      return selectedSet ? (parseFloat(selectedSet.getAttribute('data-price')) || 0) : 0;
    }
    function currentVariantId() {
      return selectedSet ? selectedSet.getAttribute('data-variant-id') : null;
    }
    function applyDisplayedPrice() {
      var baseCents = selectedBaseCents();
      if (!baseCents) return;
      var saleCents = baseCents;
      var c = discountCache[currentVariantId()];
      if (c && c.compareCents && Math.abs(c.compareCents - baseCents) <= 2 && c.saleCents < baseCents - 1) {
        saleCents = c.saleCents;
      }
      if (priceEl) priceEl.textContent = money(saleCents);
      if (submitPrice) submitPrice.textContent = money(saleCents);
      if (comparePriceEl) {
        comparePriceEl.textContent = money(baseCents);
        comparePriceEl.hidden = !(saleCents < baseCents - 1);
      }
      if (discountBadgeEl) {
        if (saleCents < baseCents - 1) {
          discountBadgeEl.textContent = '-' + Math.max(1, Math.round((1 - saleCents / baseCents) * 100)) + '%';
          discountBadgeEl.hidden = false;
        } else {
          discountBadgeEl.hidden = true;
        }
      }
      renderPricePill(setPricePill, baseCents, saleCents);
    }
    function publishVariantChange(variantId, priceCents) {
      if (variantInput) { try { variantInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        try { window.publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: sectionId, variant: { id: parseInt(variantId, 10), price: priceCents || 0, available: true } } }); } catch (e) {}
      }
    }
    // Poll Discount Mixer's shadow DOM until it has computed for this variant; cache only a price-matched pair.
    function readMixerInto(variantId, expectedBaseCents) {
      return new Promise(function (resolve) {
        var tries = 0;
        (function poll() {
          var pair = readDiscountMixerPair(discountSource || root);
          if (pair && pair.saleCents && pair.compareCents && pair.saleCents < pair.compareCents - 1 &&
              (!expectedBaseCents || Math.abs(pair.compareCents - expectedBaseCents) <= 2)) {
            discountCache[variantId] = pair; resolve(pair); return;
          }
          if (++tries > 16) { resolve(null); return; }
          window.setTimeout(poll, 200);
        })();
      });
    }
    // Re-render the price source for a variant (Section Rendering) so Mixer recomputes, then cache it.
    function loadVariantDiscount(variantId, priceCents) {
      if (!discountSource || !productHandle || !sectionId) { publishVariantChange(variantId, priceCents); return readMixerInto(variantId, priceCents); }
      if (inflightAbort) { try { inflightAbort.abort(); } catch (e) {} }
      var ac = ('AbortController' in window) ? new AbortController() : null;
      inflightAbort = ac;
      if (variantInput) variantInput.value = variantId;
      var url = '/products/' + productHandle + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
      var restore = function () { if (variantInput) variantInput.value = currentVariantId() || variantInput.value; };
      return fetch(url, { credentials: 'same-origin', signal: ac ? ac.signal : undefined }).then(function (r) { return r.text(); }).then(function (html) {
        try {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ecm-discount-source]');
          if (fresh) { discountSource.innerHTML = fresh.innerHTML; }
        } catch (e) {}
        publishVariantChange(variantId, priceCents);
        return readMixerInto(variantId, priceCents);
      }).then(function (pair) { restore(); return pair; }).catch(function () { restore(); return null; });
    }
    // Debounced, cache-first discount request for a clicked set.
    function requestDiscountFor(btn) {
      var vid = btn.getAttribute('data-variant-id');
      var price = parseFloat(btn.getAttribute('data-price')) || 0;
      if (discountCache[vid]) { applyDisplayedPrice(); return; }
      var myToken = ++jobToken;
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(function () {
        loadVariantDiscount(vid, price).then(function () {
          if (myToken === jobToken && currentVariantId() === vid) applyDisplayedPrice();
        });
      }, 160);
    }
    // Default variant is already server-rendered + Mixer-enhanced on load — just read it.
    function primeDefault() {
      var vid = currentVariantId(); if (!vid) return;
      readMixerInto(vid, selectedBaseCents()).then(function () { if (currentVariantId() === vid) applyDisplayedPrice(); });
    }
    // Warm the cache for the other sets during idle so later clicks are instant. Stops once the user clicks.
    function prefetchOthers() {
      var btns = [].slice.call(root.querySelectorAll('[data-ecm-set]'));
      var i = 0;
      (function step() {
        if (userInteracted || i >= btns.length) return;
        var b = btns[i++];
        var vid = b.getAttribute('data-variant-id');
        if (discountCache[vid]) { step(); return; }
        loadVariantDiscount(vid, parseFloat(b.getAttribute('data-price')) || 0).then(function () { step(); });
      })();
    }

    // ---- colors ----
    var COLOR_WORD_MAP = {
      czarna: 'czarny',
      czarny: 'czarny',
      czerwona: 'czerwony',
      czerwony: 'czerwony',
      niebieska: 'niebieski',
      niebieski: 'niebieski',
      szara: 'ciemnoszary',
      szary: 'ciemnoszary',
      ciemnoszary: 'ciemnoszary',
      brazowa: 'brązowy',
      brazowy: 'brązowy',
      'brązowa': 'brązowy',
      'brązowy': 'brązowy',
      bezowa: 'beżowy',
      bezowy: 'beżowy',
      'beżowa': 'beżowy',
      'beżowy': 'beżowy'
    };
    function normalizeColorWord(raw) {
      var key = String(raw || '').toLowerCase().trim();
      if (COLOR_WORD_MAP[key]) return COLOR_WORD_MAP[key];
      var ascii = key.replace(/ą/g, 'a').replace(/ć/g, 'c').replace(/ę/g, 'e')
        .replace(/ł/g, 'l').replace(/ń/g, 'n').replace(/ó/g, 'o')
        .replace(/ś/g, 's').replace(/ź/g, 'z').replace(/ż/g, 'z');
      if (COLOR_WORD_MAP[ascii]) return COLOR_WORD_MAP[ascii];
      return key;
    }
    function parseEcoColor(label) {
      var text = String(label || '').trim();
      var match = text.match(/^(.+?),\s*nić\s+(.+)$/i);
      var materialRaw = match ? match[1].trim() : text;
      var trimRaw = match ? match[2].trim() : text;
      return {
        material: normalizeColorWord(materialRaw),
        trim: normalizeColorWord(trimRaw)
      };
    }
    function applyColorProps(label) {
      var parsed = parseEcoColor(label);
      if (materialProp) materialProp.value = parsed.material;
      if (trimProp) trimProp.value = parsed.trim;
    }
    var colors = [];
    try { colors = JSON.parse(root.querySelector('[data-ecm-colors-json]').textContent); } catch (e) {}
    if (colors[0] && colors[0].label) applyColorProps(colors[0].label);
    colors.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ecm-color' + (i === 0 ? ' is-active' : '');
      b.innerHTML = '<img src="' + c.swatch + '" alt="' + c.label + '">';
      b.addEventListener('click', function () {
        colorWrap.querySelectorAll('.ecm-color').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        previews.forEach(function (preview) { preview.src = c.preview; });
        captions.forEach(function (caption) { caption.textContent = c.label; });
        if (colorName) colorName.textContent = c.label;
        applyColorProps(c.label);
      });
      colorWrap.appendChild(b);
    });

    // ---- sets ----
    function selectSet(btn, isInit) {
      root.querySelectorAll('[data-ecm-set]').forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selectedSet = btn;
      if (variantInput) variantInput.value = btn.getAttribute('data-variant-id');
      if (setName) setName.textContent = btn.getAttribute('data-name');
      applyDisplayedPrice();
      if (isInit) {
        primeDefault();
      } else {
        userInteracted = true;
        requestDiscountFor(btn);
      }
    }
    root.querySelectorAll('[data-ecm-set]').forEach(function (btn) { btn.addEventListener('click', function () { selectSet(btn, false); }); });
    var firstSet = root.querySelector('[data-ecm-set]');
    if (firstSet) selectSet(firstSet, true);
    window.addEventListener('load', function () { if (!discountCache[currentVariantId()]) primeDefault(); });
    if ('requestIdleCallback' in window) { requestIdleCallback(prefetchOthers, { timeout: 3500 }); } else { window.setTimeout(prefetchOthers, 1800); }

    // ---- sets available per seat layout -------------------------------------
  // A 2-seater has no rear row, so those sets must not be offered. Icons come
  // from the main config template.
  var SETS_2OS = ['Przód', 'Przód + bagażnik', 'Mata do bagażnika'];
  var SET_ICONS = (function () {
    // the tag sits next to the configurator, not inside it
    var tag = root.querySelector('[data-ecm-set-icons]') || document.querySelector('[data-ecm-set-icons]');
    if (!tag) return {};
    try { return JSON.parse(tag.textContent) || {}; } catch (e) { return {}; }
  })();

  function applySeat(seat) {
    var icons = SET_ICONS[seat || '5os'] || null;
    var visible = [];
    root.querySelectorAll('[data-ecm-set]').forEach(function (btn) {
      var name = btn.getAttribute('data-name') || '';
      var allowed = seat !== '2os' || SETS_2OS.indexOf(name) > -1;
      btn.hidden = !allowed;
      btn.style.display = allowed ? '' : 'none';
      if (allowed) visible.push(btn);
      var img = btn.querySelector('img');
      if (!img) return;
      if (!img.getAttribute('data-photo-src')) img.setAttribute('data-photo-src', btn.getAttribute('data-photo') || img.getAttribute('src') || '');
      var next = icons && icons[name] ? icons[name] : img.getAttribute('data-photo-src');
      if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
    });
    var active = root.querySelector('[data-ecm-set].is-active');
    if ((!active || active.hidden) && visible.length) selectSet(visible[0], false);
  }

  // ---- vehicle cascade (data: {brand:{model:[{generation,bodies}]}}) ----
    var DATA = {};
    var brandInput = root.querySelector('[data-ecm-brand]');
    var modelInput = root.querySelector('[data-ecm-model]');
    var genSel = root.querySelector('[data-ecm-gen]');
    var bodySel = root.querySelector('[data-ecm-body]');
    var propBrand = root.querySelector('[data-ecm-prop-brand]');
    var propModel = root.querySelector('[data-ecm-prop-model]');
    var propYear = root.querySelector('[data-ecm-prop-year]');
    var propBody = root.querySelector('[data-ecm-prop-body]');
    var st = { brand: '', model: '' };

    var stepValue = root.querySelector('[data-ecm-step-value]');
    var stepError = root.querySelector('[data-ecm-step-error]');
    function vehicleComplete() { return !!(st.brand && st.model && genSel.value && bodySel.value); }
    function syncProp() {
      var generation = genSel ? genSel.value : '';
      var body = bodySel ? bodySel.value : '';
      if (propBrand) propBrand.value = st.brand || '';
      if (propModel) propModel.value = st.model || '';
      if (propYear) propYear.value = generation || '';
      if (propBody) propBody.value = body || '';
      var v = [st.brand, st.model, generation, body].filter(Boolean).join(' · ');
      if (stepValue) stepValue.textContent = v;
      if (stepError && vehicleComplete()) stepError.hidden = true;
    }
    function fillCombo(ctrl, items, ph, enable) {
      ctrl.setItems(items);
      ctrl.reset(ph, enable);
    }
    function cleanVehicleText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }
    function splitVehicleModel(model, generation) {
      var modelText = cleanVehicleText(model);
      var genText = cleanVehicleText(generation);
      var match = modelText.match(/^(.+?)\s+((?:[IVXLCDM]+|\d+)\s+gen)$/i);
      if (!match) return { model: modelText, generation: genText };
      return {
        model: cleanVehicleText(match[1]),
        generation: cleanVehicleText(match[2] + (genText ? ' ' + genText : ''))
      };
    }
    function normalizeBodyLabel(body) {
      var text = cleanVehicleText(body);
      var lower = text.toLowerCase();
      var base = text
        .replace(/\b(?:5|7)\s*(?:os|os\.|osobowy|osobowa|miejscowy|miejscowa)\b/ig, '')
        .replace(/\s+/g, ' ')
        .trim();
      if (/^suv$/i.test(base)) base = 'SUV';
      if (!base) base = text;
      if (/\b7\s*(?:os|os\.|osobowy|osobowa|miejscowy|miejscowa)\b/i.test(lower)) return base + ' 7 osobowy';
      if (/\b5\s*(?:os|os\.|osobowy|osobowa|miejscowy|miejscowa)\b/i.test(lower)) return base + ' 5 osobowy';
      return /^suv$/i.test(text) ? 'SUV' : text;
    }
    function uniqueList(items) {
      var seen = {};
      return items.filter(function (item) {
        if (seen[item]) return false;
        seen[item] = true;
        return true;
      });
    }
    function normalizeVehicleData(data) {
      var normalized = {};
      Object.keys(data || {}).forEach(function (brand) {
        normalized[brand] = {};
        Object.keys(data[brand] || {}).forEach(function (modelKey) {
          (data[brand][modelKey] || []).forEach(function (entry) {
            var split = splitVehicleModel(modelKey, entry.generation);
            var model = split.model;
            var generation = split.generation || cleanVehicleText(entry.generation);
            var bodies = uniqueList((entry.bodies || []).map(normalizeBodyLabel));
            if (!normalized[brand][model]) normalized[brand][model] = [];
            var existing = normalized[brand][model].filter(function (item) { return item.generation === generation; })[0];
            // carry the seat layout through: body labels are normalised here, so remap its keys
            var seatMap = {};
            var rawSeat = entry.seatByBody || {};
            Object.keys(rawSeat).forEach(function (key) { seatMap[normalizeBodyLabel(key)] = rawSeat[key]; });
            if (existing) {
              existing.bodies = uniqueList(existing.bodies.concat(bodies));
              existing.seatByBody = existing.seatByBody || {};
              Object.keys(seatMap).forEach(function (key) {
                if (!existing.seatByBody[key]) existing.seatByBody[key] = seatMap[key];
              });
            } else {
              normalized[brand][model].push({ generation: generation, bodies: bodies, seatByBody: seatMap });
            }
          });
        });
      });
      return normalized;
    }
    function combo(comboEl, onPick) {
      var input = comboEl.querySelector('.ecm-combo-input');
      var list = comboEl.querySelector('.ecm-combo-list');
      var items = [];
      var selected = '';
      function render(showAll) {
        var f = showAll ? '' : input.value.toLowerCase();
        list.innerHTML = '';
        var matched = items.filter(function (t) { return t.toLowerCase().indexOf(f) >= 0; });
        if (!matched.length) { list.innerHTML = '<li class="ecm-combo-empty">Brak wyników</li>'; list.hidden = false; return; }
        matched.slice(0, 200).forEach(function (t) {
          var li = document.createElement('li');
          li.className = 'ecm-combo-opt' + (t === selected ? ' is-selected' : '');
          var text = document.createElement('span');
          text.textContent = t;
          li.appendChild(text);
          if (t === selected) {
            var check = document.createElement('span');
            check.className = 'ecm-combo-check';
            check.textContent = '✓';
            li.appendChild(check);
          }
          li.addEventListener('mousedown', function (e) { e.preventDefault(); selected = t; input.value = t; list.hidden = true; onPick(t); });
          list.appendChild(li);
        });
        list.hidden = false;
      }
      input.addEventListener('focus', function () { render(true); });
      input.addEventListener('click', function () { render(true); });
      input.addEventListener('input', function () { selected = ''; render(false); });
      input.addEventListener('blur', function () { setTimeout(function () { list.hidden = true; }, 150); });
      return {
        setItems: function (arr) { items = arr; },
        reset: function (ph, enabled) { selected = ''; input.value = ''; input.placeholder = ph; input.disabled = !enabled; list.hidden = true; }
      };
    }

    var bodyCombo = combo(root.querySelector('[data-ecm-combo="body"]'), function (body) {

      // seat layout comes from the dataset, so the set list matches the car

      var _e = (DATA[st.brand] && DATA[st.brand][st.model] || []).filter(function (g) { return g.generation === (genSel ? genSel.value : ''); })[0];

      applySeat((_e && _e.seatByBody && _e.seatByBody[body]) || '5os');
      bodySel.value = body;
      syncProp();
    });
    var genCombo = combo(root.querySelector('[data-ecm-combo="gen"]'), function (generation) {
      genSel.value = generation;
      var entry = (DATA[st.brand] && DATA[st.brand][st.model] || []).filter(function (g) { return g.generation === generation; })[0];
      var bodies = entry && entry.bodies ? entry.bodies : [];
      fillCombo(bodyCombo, bodies, bodies.length ? 'Wybierz nadwozie…' : '—', bodies.length > 0);
      syncProp();
    });

    var modelCombo = combo(root.querySelector('[data-ecm-combo="model"]'), function (model) {
      st.model = model;
      var gens = (DATA[st.brand] && DATA[st.brand][model] ? DATA[st.brand][model] : []).map(function (g) { return g.generation; });
      fillCombo(genCombo, gens, gens.length ? 'Wybierz generację…' : 'Brak danych', gens.length > 0);
      fillCombo(bodyCombo, [], 'Najpierw wybierz generację', false);
      syncProp();
    });
    var brandCombo = combo(root.querySelector('[data-ecm-combo="brand"]'), function (brand) {
      st.brand = brand; st.model = '';
      var models = DATA[brand] ? Object.keys(DATA[brand]).sort() : [];
      modelCombo.setItems(models);
      modelCombo.reset(models.length ? 'Wpisz model…' : 'Brak modeli', models.length > 0);
      fillCombo(genCombo, [], 'Najpierw wybierz model', false);
      fillCombo(bodyCombo, [], 'Najpierw wybierz generację', false);
      syncProp();
    });

    var vehiclesLoaded = false;
    function loadVehicles() {
      if (vehiclesLoaded) return;
      vehiclesLoaded = true;
      fetch(root.getAttribute('data-vehicles')).then(function (r) { return r.json(); }).then(function (data) {
        DATA = normalizeVehicleData(data);
        brandCombo.setItems(Object.keys(DATA).sort());
      }).catch(function () { vehiclesLoaded = false; });
    }
    var brandInputEl = root.querySelector('[data-ecm-combo="brand"] .ecm-combo-input');
    if (brandInputEl) {
      brandInputEl.addEventListener('focus', loadVehicles, { once: true });
      brandInputEl.addEventListener('pointerdown', loadVehicles, { once: true });
    }
    if ('requestIdleCallback' in window) { requestIdleCallback(loadVehicles, { timeout: 4000 }); } else { setTimeout(loadVehicles, 3000); }

    // ---- accordion steps (config-style) ----
    var steps = [].slice.call(root.querySelectorAll('.ecm-step'));
    function openStep(step) {
      steps.forEach(function (s) { if (s !== step) s.classList.remove('is-open'); });
      step.classList.remove('is-disabled');
      step.classList.add('is-open');
    }
    steps.forEach(function (step) {
      var head = step.querySelector('.ecm-step-head');
      if (head) head.addEventListener('click', function () {
        if (step.classList.contains('is-disabled')) return;
        if (step.classList.contains('is-open')) step.classList.remove('is-open');
        else openStep(step);
      });
      var next = step.querySelector('.ecm-step-next');
      if (next) next.addEventListener('click', function () {
        if (step === steps[0] && !vehicleComplete()) { if (stepError) stepError.hidden = false; return; }
        if (stepError) stepError.hidden = true;
        step.classList.remove('is-open');
        step.classList.add('is-done');
        var idx = steps.indexOf(step);
        if (idx > -1 && steps[idx + 1]) openStep(steps[idx + 1]);
      });
    });
    var ecmForm = root.querySelector('[data-ecm-form]');
    if (ecmForm) ecmForm.addEventListener('submit', function (e) {
      if (!vehicleComplete()) {
        e.preventDefault();
        if (stepError) stepError.hidden = false;
        if (steps[0]) openStep(steps[0]);
      }
    });

    // ---- description tabs ----
    var dtabs = [].slice.call(root.querySelectorAll('[data-ecm-desc-tab]'));
    var dpanels = [].slice.call(root.querySelectorAll('[data-ecm-desc-panel]'));
    dtabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.getAttribute('data-ecm-desc-tab');
        dtabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        dpanels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ecm-desc-panel') === k); });
      });
    });

    // ---- gallery (fast arrow strip, like organizer) ----
    var mainImg = root.querySelector('[data-ecm-main-img]');
    var box = root.querySelector('[data-ecm-lightbox]');
    var boxImg = root.querySelector('[data-ecm-lightbox-img]');
    function openBox(src) { if (box && boxImg) { boxImg.src = src; box.hidden = false; } }
    function closeBox() { if (box) box.hidden = true; }
    var galleryJsonEl = root.querySelector('[data-ecm-gallery-json]');
    var gallery = root.querySelector('[data-ecm-gallery]');
    if (galleryJsonEl && gallery && mainImg) {
      var gitems = [];
      try { gitems = JSON.parse(galleryJsonEl.textContent); } catch (e) {}
      var thumbsWrap = gallery.querySelector('[data-ecm-thumbs]');
      var gprev = gallery.querySelector('[data-ecm-gallery-prev]');
      var gnext = gallery.querySelector('[data-ecm-gallery-next]');
      var gActive = 0;
      if (thumbsWrap) thumbsWrap.innerHTML = gitems.map(function (it, i) {
        return '<button type="button" class="ecm-thumb' + (i === 0 ? ' is-active' : '') + '" data-ecm-gindex="' + i + '"><img src="' + (it.thumb || it.src) + '" alt="" loading="lazy"></button>';
      }).join('');
      // preload full-size images so arrow paging is instant — deferred to idle so it doesn't compete with initial load
      function preloadGallery() { gitems.forEach(function (it) { var im = new Image(); im.src = it.src; }); }
      if ('requestIdleCallback' in window) { requestIdleCallback(preloadGallery, { timeout: 3000 }); } else { setTimeout(preloadGallery, 2500); }
      function gSet(i) {
        gActive = Math.max(0, Math.min(gitems.length - 1, i));
        var it = gitems[gActive]; if (!it) return;
        mainImg.src = it.src; mainImg.alt = it.alt || '';
        var btn = thumbsWrap && thumbsWrap.querySelector('[data-ecm-gindex="' + gActive + '"]');
        if (thumbsWrap) thumbsWrap.querySelectorAll('.ecm-thumb').forEach(function (x) { x.classList.toggle('is-active', x === btn); });
        if (btn && thumbsWrap) thumbsWrap.scrollTo({ left: btn.offsetLeft - thumbsWrap.offsetLeft, behavior: 'smooth' });
        if (gprev) gprev.disabled = gActive === 0;
        if (gnext) gnext.disabled = gActive === gitems.length - 1;
      }
      if (thumbsWrap) thumbsWrap.querySelectorAll('[data-ecm-gindex]').forEach(function (b) {
        b.addEventListener('click', function () { gSet(Number(b.getAttribute('data-ecm-gindex'))); });
      });
      if (gprev) gprev.addEventListener('click', function () { gSet(gActive - 1); });
      if (gnext) gnext.addEventListener('click', function () { gSet(gActive + 1); });
      gSet(0);
    }
    var mainWrap = root.querySelector('[data-ecm-gallery-main]');
    if (mainWrap && mainImg) mainWrap.addEventListener('click', function () { openBox(mainImg.src); });
    if (box) {
      box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
      var cl = root.querySelector('[data-ecm-lightbox-close]'); if (cl) cl.addEventListener('click', closeBox);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });
    }
  });
})();
